export default "__VITE_ASSET__CsknlB0Q__"